import React from "react"

import "./video-embed.css"

const getMargin = alignment => {
  switch (alignment) {
    case "left":
      return { marginLeft: "0", marginRight: "auto" }
    case "right":
      return { marginLeft: "auto", marginRight: "0" }
    default:
      return { marginLeft: "auto", marginRight: "auto" }
  }
}

export const VideoEmbed = ({
  href,
  width,
  embedHtml,
  alignment,
  children,
  editing,
  ...props
}) => {
  const { marginLeft, marginRight } = getMargin(alignment)

  return (
    <div {...props}>
      <div
        className="editor-video-embed relative w-full"
        style={{
          marginLeft,
          marginRight,
          maxWidth: `${width}px`,
          height: width / (16 / 9)
        }}
      >
        <div
          className="relative w-full h-full editor-video-wrap"
          dangerouslySetInnerHTML={{ __html: embedHtml }}
        />
        {editing && (
          <div className="editor-video-embed-toggle">Embed options</div>
        )}
      </div>
      {children}
    </div>
  )
}

VideoEmbed.defaultProps = {
  width: 480,
  alignment: "center",
  editing: false
}
